/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardWithUserReissueOneOf1
 */
export interface CardWithUserReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserReissueOneOf1
     */
    'cardType': CardWithUserReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof CardWithUserReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const CardWithUserReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type CardWithUserReissueOneOf1CardTypeEnum = typeof CardWithUserReissueOneOf1CardTypeEnum[keyof typeof CardWithUserReissueOneOf1CardTypeEnum];


